
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SupportTicketTypingIndicator extends Vue {
  @Prop({ type: String, required: true }) name!: string;
}
